import { ColorPalette } from '../soho/ColorPalette';

const markdown = `
  .markdown-body {
      color: inherit;
  }

  .markdown-body .highlight pre,
  .markdown-body pre {
    background-color: ${ColorPalette.$slate10};
  }
`;

export default markdown;
